module.exports = __webpack_public_path__ + "0.5d7e05d9942c37dec60c.worker.js"